//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UnionSync from './components/UnionSync.vue';
export default {
  name: 'UnionSyncPage',
  components: {
    UnionSync: UnionSync
  },
  methods: {
    refreshPage: function refreshPage() {
      this.$message.info('正在刷新页面...');
      location.reload();
    },
    handleSyncCompleted: function handleSyncCompleted(syncType) {
      console.log('同步完成:', syncType);
      // 可以在这里添加同步完成后的处理逻辑
      // 比如刷新其他页面的数据等
    }
  }
};